<template>
<div>
	<modal-dialog :modal-visible="visible"
		:title="title"
		modal-size="modal-lg"
		confirm-button-text="Save"
		cancel-button-text="Done"
		:submit-visible="!readonly"
		v-on:confirm="saveAssembly"
		v-on:closeModal="closeModal">

		<slot></slot>

		<field label="Assembly Description" col-class="col-md-4"
			v-model="payload.description"
			:readonly="readonly"
			:invalid="$store.errorList.description">
		</field>

		<field label="Assembly Unit Type" col-class="col-md-4"
			:params="{type:'select',options: ['Unit','Metre','Foot']}"
			v-model="payload.unit_type"
			:readonly="readonly"
			:invalid="$store.errorList.description">
			<p class="text-muted">How the assembly is measured</p>
		</field>

		<field label="Tags" col-class="col-md-4"
			:readonly="readonly"
			:params="{type:'select-multi',options: tagOptions}"
			:invalid="$store.errorList.AssemblyTag"
			v-model="payload.AssemblyTag">
		</field>

		<div v-if="'id' in payload && payload.id">
			<div v-for="locationBox in locationBoxes" v-if="payload.unit_type != 'Unit' || locationBox.key == 'Single'" class="location-box">

				<div class="d-flex flex-row align-items-center flex-wrap mb-2 justify-content-between">
					<h3 class="mb-0 mr-4">{{ locationBox.heading }}</h3>
					<div style="max-width: 500px" class="d-flex flex-row align-items-center">
						<info-box label="Material Cost" :value="sectionMaterialCost[locationBox.key]" :stacked="true" class="flex-grow-1"></info-box>
						<info-box label="Labour Hrs (Materials)" :value="sectionLabourHrs.materials[locationBox.key]" :stacked="true" class="flex-grow-1"></info-box>
						<info-box label="Labour Hrs (Tasks)" :value="sectionLabourHrs.tasks[locationBox.key]" :stacked="true" class="flex-grow-1"></info-box>
					</div>
				</div>
				
				<div v-if="splitItems[locationBox.key]" class="row no-gutters row-eq-height">
					<div class="col-md-6">
						<div class="location-box-bucket">
							<div class="d-flex flex-row justify-content-between align-items-center flex-wrap mb-2">
								<h4>Materials</h4>

								<button v-if="!readonly" class="btn btn-dark btn-sm mr-2" v-on:click="addMaterials(locationBox.key)" type="button">
									<i class="fa fa-plus"></i>
									Add...
								</button>
							</div>

							<component :is="readonly ? 'div' : 'draggable'" 
								tag="ul"
								group="materials"
								:key="'mats_'+locationBox.key" 
								class="location-box-bucket-inner list-group"
								v-on:change="dragChange($event,locationBox.key,'materials')"
								v-model="splitItems[locationBox.key].materials">

								<li v-for="item in splitItems[locationBox.key].materials" class="list-group-item">
									<div class="d-flex flex-row justify-content-between align-items-center">
										<h5 class="flex-grow-1 mr-2 mb-0">{{ item.Material.part_number }}<br v-if="item.Material.part_number"><small>{{ item.Material.description }}</small></h5>
										<div class="qty mr-2">
											<div class="field-wrapper">
												<field :readonly="readonly"
													:params="{type:'number',step:0.01,placeholder:'Qty'}" 
													v-on:change="elementQtyChange('material',locationBox.key,item,$event)"
													v-model="item.qty">
												</field>
											</div>
										</div>
										
										<i v-if="!readonly" class="fa fa-trash icon-button text-danger" v-on:click="removeItem(item)"></i>
									</div>
								</li>
							</component>
						</div>
					</div>
					<div class="col-md-6">
						<div class="location-box-bucket">
							<div class="d-flex flex-row justify-content-between align-items-center flex-wrap mb-2">
								<h4>Labour Tasks</h4>

								<button v-if="!readonly" class="btn btn-dark btn-sm" v-on:click="addLabourAction(locationBox.key)" type="button">
									<i class="fa fa-plus"></i>
									Add...
								</button>
							</div>

							<component :is="readonly ? 'div' : 'draggable'" tag="ul" 
								group="tasks"
								class="location-box-bucket-inner list-group" 
								:key="'tasks_'+locationBox.key" 
								v-on:change="dragChange($event,locationBox.key,'tasks')"
								v-model="splitItems[locationBox.key].tasks">

								<li v-for="item in splitItems[locationBox.key].tasks" class="list-group-item">
									<div class="d-flex flex-row justify-content-between align-items-center">
										<h5 class="flex-grow-1 mr-2 mb-0">{{ item.LabourAction.description }}</h5>
										<div class="qty mr-2">
											<div class="field-wrapper">
												<field 
													:params="{type:'number',step:0.01,placeholder:'Qty'}" 
													:readonly="readonly"
													v-on:change="elementQtyChange('task',locationBox.key,item,$event)"
													v-model="item.qty">
												</field>
											</div>
										</div>
										<i v-if="!readonly" class="fa fa-trash icon-button text-danger" v-on:click="removeItem(item)"></i>
									</div>
								</li>
							</component>
						</div>
					</div>
				</div>

				<div class="notes-panel mt-3">
					<button v-if="!readonly && !noteBoxVisible[locationBox.noteKey]" class="btn btn-sm btn-light" type="button" v-on:click="noteBoxVisible[locationBox.noteKey] = true">
						<i class="fa fa-pencil"></i>
						<template v-if="!payload[locationBox.noteKey]">Add Note</template>
						<template v-else>Edit Note</template>
					</button>

					<field v-if="noteBoxVisible[locationBox.noteKey]"
						label="Note"
						col-class="stacked"
						:params="{type: 'textarea'}"
						:readonly="readonly"
						v-model="payload[locationBox.noteKey]">
					</field>
				</div>
			</div>
		</div>
		<div v-else class="float-right">
			<button class="btn btn-light">
				Add Materials & Tasks
				<i class="fa fa-chevron-right"></i>
			</button>
		</div>
		<div style="clear: both;"></div>

	</modal-dialog>

	<material-selector-modal v-if="!readonly" :visible="materialSelectorModal.visible"
		:disable-manual="true"
		:disable-price="true"
		:disable-assemblies="true"
		v-on:addMaterials="confirmMaterialSelection"
		v-on:closeModal="materialSelectorModal.visible = false">
	</material-selector-modal>

	<labour-action-selector-modal v-if="!readonly" :visible="taskSelectorModal.visible"
		:disable-manual="true"
		v-on:addTasks="confirmTaskSelection"
		v-on:closeModal="taskSelectorModal.visible = false">
	</labour-action-selector-modal>
</div>

</template>
<script type="text/javascript">
import ModalDialog from "@/components/ModalDialog"
import draggable from "vuedraggable"
import Field from "@/components/Field"
import InfoBox from "@/components/InfoBox"

import MaterialSelectorModal from "@/components/super_components/MaterialSelectorModal"
import LabourActionSelectorModal from "@/components/super_components/LabourActionSelectorModal"

export default {
	name: "AssemblyDetailsModal",
	components: {
		ModalDialog,
		draggable,
		Field,
		InfoBox,
		MaterialSelectorModal,
		LabourActionSelectorModal
	},
	props: [
		"readonly",
		"visible",
		"title",
		"record"
	],
	data() {
		return {
			payload: {
				description: "",
				unit_type: null,
				note_unit: "",
				note_linear: "",
				note_segments: ""
			},
			assemblyItems: [],
			splitItems: [],
			tags: [],
			working: false,
			materialSelectorModal: {
				visible: false,
				location: ""
			},
			taskSelectorModal: {
				visible: false,
				location: ""
			},
			noteBoxVisible: {
				note_unit: false,
				note_linear: false,
				note_segments: false
			}
		}
	},
	watch: {
		visible() {
			if (this.record && "id" in this.record) {
				this.fetchAssemblyItems(this.record.id)

				if (!("AssemblyTag" in this.record) || this.record.AssemblyTag.length == 0) 
					this.fetchAssemblyTagInclude()
			}

			this.setPayload()
		}
	},
	computed: {
		tagOptions() {
			return this.optionify(this.tags,"name")
		},
		sectionMaterialCost() {

			let totals = {
				Single: 0,
				Line: 0,
				Segment: 0
			}

			this.assemblyItems.filter(item => item.material_id > 0).forEach(matItem => {
				totals[matItem.location] += +matItem.Material.material_price / +matItem.Material.per * matItem.qty
			})

			Object.keys(totals).forEach(key => {
				totals[key] = "$ "+totals[key].toFixed(2)
			})

			return totals
		},
		sectionLabourHrs() {
			let totals = {
				materials: {
					Single: 0,
					Line: 0,
					Segment: 0
				},
				tasks: {
					Single: 0,
					Line: 0,
					Segment: 0
				}
			}

			this.assemblyItems.forEach(matItem => {

				if ("Material" in matItem && matItem.Material)
					totals.materials[matItem.location] += +matItem.Material.labour_hrs / +matItem.Material.per * matItem.qty

				if ("LabourAction" in matItem && matItem.LabourAction)
					totals.tasks[matItem.location] += +matItem.LabourAction.labour_hrs * matItem.qty
			})



			Object.keys(totals.materials).forEach(key => {
				totals.materials[key] = totals.materials[key].toFixed(2)+" hrs"
			})

			Object.keys(totals.tasks).forEach(key => {
				totals.tasks[key] = totals.tasks[key].toFixed(2)+" hrs"
			})

			return totals
		},
		locationBoxes() {

			let linearUnit = "Unit"
			if (this.payload && "unit_type" in this.payload)
				linearUnit = this.payload.unit_type

			return [
				{
					heading: "Per Assembly",
					key: "Single",
					noteKey: "note_unit"
				},
				{
					heading: "Per Linear "+linearUnit,
					key: "Line",
					noteKey: "note_linear"
				},
				{
					heading: "Per Segment",
					key: "Segment",
					noteKey: "note_segments"
				},
			]
		},
	},
	methods: {
		setPayload() {
			let vm = this
			if (!this.record) {
				this.clearPayload()
			}
			else
				this.payload = this.record

			let noteFields = ["note_unit","note_linear","note_segments"]
			noteFields.forEach(field => {

				if (vm.payload[field])
					vm.noteBoxVisible[field] = true
				else
					vm.noteBoxVisible[field] = false
			})

		},
		clearPayload() {
			this.payload = {
				description: "",
				unit_type: null,
				note_linear: "",
				note_segments: "",
				note_unit: "",
				AssemblyTag: []
			}
		},
		closeModal() {
			this.clearPayload()
			this.$store.errorList.AssemblyTag = false
			this.$emit('closeModal')
		},
		splitItemsToLocations(items) {
			let locations = {}
			this.locationBoxes.forEach(loc => {
				locations[loc.key] = {
					materials: [],
					tasks: []
				}
			})

			items.forEach(item => {
				if (item.action_id > 0)
					locations[item.location].tasks.push(item)
				else
					locations[item.location].materials.push(item)
			})

			this.splitItems = locations
		},
		dragChange(event,location,type) {
			let vm = this

			if ("added" in event) {
				//update the location
				let obj = event.added.element

				let payload = {
					id: obj.id,
					location
				}

				this.postData("MaterialAssemblyItem/save",payload)
			}
		},
		elementQtyChange(type,location,element,qty) {
			let vm = this

			let payload = {
				id: element.id,
				qty: qty
			}

			this.postData("MaterialAssemblyItem/save",payload)
		},
		addMaterials(location) {
			this.materialSelectorModal.visible = true
			this.materialSelectorModal.location = location
		},
		confirmMaterialSelection(materials) {
			let vm = this

			let assembly_id = this.payload.id

			let payload = {
				records: JSON.stringify(materials.map(mat => {
					return {
						assembly_id: assembly_id,
						qty: mat.qty,
						material_id: mat.id,
						location: vm.materialSelectorModal.location
					}
				}))
			}

			this.postData("MaterialAssemblyItem/save-batch",payload,true).then(response => {
				if (response.success) {
					vm.alertSaved("Materials added to assembly")
					vm.materialSelectorModal.visible = false
					vm.fetchAssemblyItems(assembly_id)
				}
				
			})
		},
		addLabourAction(location) {
			this.taskSelectorModal.visible = true
			this.taskSelectorModal.location = location
		},
		confirmTaskSelection(tasks) {
			let vm = this

			let assembly_id = this.payload.id

			let payload = {
				records: JSON.stringify(tasks.map(task => {
					return {
						assembly_id: assembly_id,
						qty: task.qty,
						action_id: task.id,
						location: vm.taskSelectorModal.location
					}
				}))
			}

			this.postData("MaterialAssemblyItem/save-batch",payload,true).then(response => {
				if (response.success) {
					vm.alertSaved("Tasks added to assembly")
					vm.taskSelectorModal.visible = false
					vm.fetchAssemblyItems(assembly_id)
				}
			})
		},
		saveAssembly() {
			let vm = this

			this.working = true

			let assemblyPayload = this.cloneObj(this.payload)

			if (!("AssemblyTag" in assemblyPayload) || assemblyPayload.AssemblyTag.length == 0) {
				vm.$store.errorList.AssemblyTag = true

				vm.alertFail("Please set at least one tag")
				vm.$forceUpdate()
			}
			else {

				delete this.payload.Material

				let keepModalOpen = true
				if ("id" in this.payload && this.payload.id)
					keepModalOpen = false
					//this is an edit, we need to chain the post requests
				this.postData("MaterialAssembly/save",assemblyPayload,true).then(response => {
					vm.working = false

					if (response.success) {
						vm.alertSaved("Material assembly saved!")

						vm.$store.errorList = {}

						if (!keepModalOpen) {
							vm.$emit('closeModal')
							vm.payload = {}	
						}
						if (!("id" in vm.payload))
							vm.payload.id = response.record_id

						this.fetchAssemblyItems(response.record_id)

						vm.$emit("modelChanged")
					}
				})
			}
		},
		removeItem(item) {
			let vm = this

			this.postData("MaterialAssemblyItem/delete",{id:item.id},true).then(response => {
				if (response.success) {
					vm.fetchAssemblyItems(vm.payload.id)
				}
			})
		},
		fetchAssemblyItems(assembly_id) {
			let vm = this

			let params = {
				filters: [
					["assembly_id",assembly_id]
				],
				include: ["Material","LabourAction"]
			}

			return new Promise((resolve,reject) => {
				vm.getJSON("MaterialAssemblyItem/get",params,true).then(response => {

					if (response.success) {
						vm.assemblyItems = response.data
						vm.splitItemsToLocations(response.data)

						vm.$emit("assemblyItemsFetched",vm.assemblyItems)
					}

					resolve(response)
				})
			})
		},
		fetchData() {
			let vm = this

			this.getJSON("AssemblyTag/get").then(response => {
				if (response.success)
					vm.tags = response.data
			})
		},
		fetchAssemblyTagInclude() {
			let vm = this
			this.getJSON("MaterialAssembly/find/"+this.record.id,{include: ["AssemblyTag"]}).then(response => {
				if (response.success)
					vm.payload.AssemblyTag = vm.primitize(response.data.AssemblyTag)
			})
		}
	},
	created() {
		if (this.record && "id" in this.record) {
			this.fetchAssemblyItems(this.record.id)

			if (!("AssemblyTag" in this.record) || this.record.AssemblyTag.length == 0) 
				this.fetchAssemblyTagInclude()
		}

		this.fetchData()

		this.setPayload()

	}
}
</script>

<style scoped>

	.location-box {
		margin-left: -15px;
		margin-right: -15px;
		padding: 15px;
		border-top: 5px solid var(--brand-primary-color);
	}

	.location-box:nth-child(odd) {
		background-color: var(--brand-primary-color-faded);
	}

	.location-box-bucket {
		padding: 5px;
		background-color: #f8f9fa;
		border: 1px dashed #a0a0a0;
		margin-bottom: 10px;
		height: 100%;
	}

	.location-box-bucket-inner {
		min-height: 30px;
	}

	.location-box-bucket-inner li {
		padding: 10px;
		padding-top: 7px;
		padding-bottom: 7px;
	}

	.location-box-bucket-inner .field-wrapper {
		width: 70px;
	}

	.section-divider {
		border-top: 8px solid lightgray;
	}

	label.tag-label {
		display: block;
	}

</style>